const departments = {
    leader: 'Responsabile',
    leaders: 'Responsabili del reparto',
    led_departments: 'Reparti gestiti',
    edit_leaders: 'Gestisci responsabili',
    add_leader: 'Aggiungi',
    remove_leader: 'Rimuovi',
    no_leaders: 'Nessun responsabile',
    local: 'Gestione locale',
    managed_members: 'Membri nel proprio ambito',
    leader_scope_hint: 'Gestisci le assegnazioni dei tuoi reparti e sottoreparti.',
    leader_permission_hint: 'I responsabili gestiscono le assegnazioni dei propri reparti e sottoreparti, senza modificare ruoli o gerarchie.',
    primary_synced: 'Il reparto principale è gestito da Feishu.',
    status_active: 'Attivo',
    status_suspended: 'Sospeso',
    status_departed: 'Uscito',
    status_pending: 'In attesa di attivazione',
    search: 'Cerca',
    previous_page: 'Pagina precedente',
    next_page: 'Pagina successiva',
    directory_title: 'Membri dell’organizzazione',
    member_name: 'Membro',
    search_members: 'Cerca per nome o nome utente',
    include_descendants: 'Includi sottoreparti',
    no_members: 'Nessun membro corrispondente.',
    all_members: 'Tutti i membri',
    all_departments: 'Tutti i reparti',
    edit_member: 'Modifica reparti',
    add_child: 'Aggiungi sottoreparto',
    expand_department: 'Espandi {{name}}',
    collapse_department: 'Comprimi {{name}}',
    title: 'Reparti',
    description: 'Gestisci i reparti e le assegnazioni dei membri di questa organizzazione.',
    create: 'Crea reparto',
    edit: 'Modifica reparto',
    name: 'Nome del reparto',
    parent: 'Reparto superiore',
    root: 'Nessun reparto superiore',
    id: 'ID reparto',
    members: 'Reparti dei membri',
    member_id: 'ID utente del membro',
    primary: 'Reparto principale',
    none: 'Non impostato',
    assignments: 'Assegnazioni ai reparti',
    no_assignments: 'Nessuna assegnazione ai reparti.',
    assignment_hint: 'Assegna reparti locali e, facoltativamente, un reparto principale. Le assegnazioni della directory sono di sola lettura.',
    empty: 'Nessun reparto.',
    readonly: 'Puoi visualizzare i reparti e le tue assegnazioni. Contatta un amministratore per modificarle.',
    load_error: 'Impossibile caricare i dati. Riprova.',
    mutation_error: 'Salvataggio non riuscito. Controlla permessi, appartenenza e gerarchia dei reparti.',
    loading: 'Caricamento…',
    synced: 'Gestito dalla directory',
    choose: 'Cerca reparti',
    organizations_title: 'Organizzazioni e reparti',
    organizations_description: 'Scegli un’organizzazione per visualizzare o gestire i suoi reparti.',
    no_organizations: 'Non appartieni ad alcuna organizzazione. Contatta un amministratore.',
    organization: 'Organizzazione attuale',
    choose_organization: 'Scegli un’organizzazione',
    delete_title: 'Elimina reparto',
    delete_description: 'Eliminare «{{name}}»? Sposta prima i membri e i sottoreparti.',
};
export default Object.freeze(departments);
